module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/banners/cesu-reminder-rc-123a40ca96785a99edd6eb661a0a1308.svg";